import { render, staticRenderFns } from "./LocalizationForm.vue?vue&type=template&id=eb1be802&scoped=true&"
import script from "./LocalizationForm.vue?vue&type=script&lang=js&"
export * from "./LocalizationForm.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationForm.vue?vue&type=style&index=0&id=eb1be802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1be802",
  null
  
)

export default component.exports